import Bankruptcies from './Bankruptcies';

export default Bankruptcies;
